import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class About extends Component {
    render() {
        return (
            <div className="container">
                <h1>About</h1>
                <h2>History of the Club</h2>
                <p>The Club was formed in 1958 by a group of keen amateur photographers. The first Chairman was David Ross, owner of 'David Ross Photographic Studios' then situated in Bridge Road East Molesey. The early meetings were held in the school previously known as Ray Road School, West Molesey. Membership stood at around 25-30 in 1959. In 1967 the Club held its first exhibition in the new Molesey library. In 1968 the Club appointed its first President - David Ross - and Tom Davie became Chairman.</p>
                <p>It was at this time that the Club joined the Surrey Photographic Federation so that they could meet and compete against other member clubs. This helped members to see a much wider range of photography and hopefully help to raise the overall standard within the Club. We are members of the Surrey Photographic Association (as it now is) and also the Photographic Alliance of Great Britain.</p>

                <h2>The Club Today</h2>
                <p>The Club has 40 - 45 members all using different techniques and equipment eg, smartphones, tablets, DSLRs and compact digital cameras. We develop our programme to try to accommodate new ideas and requests from members who want to move into specialised techniques, such as macro and Infrared photography. We have monthly competitions for prints and digital images and also enter regional and national competitions.</p>
                <p>We currently meet in The East Molesey Methodist Church, Manor Road, East Molesey KT8 9JU - see the <Link to="./contact">Contact Us</Link> page for details. Please send us an <a href="mailto:molesey_photo_club@yahoo.co.uk">email</a> if you would like more information.</p>
            </div>
        );
    }
}

export default About;


// WEBPACK FOOTER //
// ./src/pages/about.jsx